<template>
    <v-container fluid>
        <v-row
            align="center"
            no-gutters
        >
            <v-col
                cols="12"
                justify="center"
                lg="4"
                sm="6"
            >
                <v-subheader>
                    <h2>Unmatched Messages ({{totalMatches}})</h2>
                </v-subheader>
            </v-col>
            <v-col
                cols="12"
                lg="4"
                sm="6"
            >
                <v-text-field v-show="false"
                    @click:clear="setSearch('')"
                    @input="setSearch"
                    clearable
                    label="Search"
                    prepend-icon="mdi-magnify"
                    single-line
                />
            </v-col>
            <v-col
                class="text-right"
                cols="12"
                lg="4"
                sm="6"
            >
                <!--<v-btn
                    @click="showFilters = !showFilters"
                    color="secondary darken-1"
                    icon
                >
                    <v-icon>mdi-tune</v-icon>
                </v-btn>-->
            </v-col>
        </v-row>
        <v-container class="pb-10">
            <v-row
                justify="center"
                v-if="unmatchedmessages === null"
            >
                <v-col
                    :key="i"
                    cols="12"
                    lg="6"
                    v-for="i in 6"
                >
                    <v-skeleton-loader
                        elevation="4"
                        type="card"
                    ></v-skeleton-loader>
                </v-col>
            </v-row>
            <v-row
                justify="center"
                v-else
            >
                <v-col
                    :key="unmatchedmessage.id"
                    cols="12"
                    lg="6"
                    v-for="unmatchedmessage in unmatchedmessages"
                >
                    <!--@click="loadUnmatchedMessageForm(unmatchedmessage.entity)"-->
                    <v-card
                        class="entity-card fill-height"
                        elevation="4"
                        style="overflow:hidden"
                    >
                        <v-card-title>
                            <h5>{{unmatchedmessage.smsNumber}}</h5>
                        </v-card-title>
                        <v-card-text class="pt-0">MessageReceived: {{unmatchedmessage.messageRecieved}}</v-card-text>
                        <v-card-text class="pt-0">MessageReceivedAt: {{unmatchedmessage.createdAt.toString()}}</v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>


        <v-pagination
            :length="pagesCount"
            @input="paginationDebounce(500, true)"
            class="pagination-bar base-background"
            total-visible="7"
            v-model="pageNo"
            v-show="pagesCount > 1"
        ></v-pagination>
    </v-container>
</template>

<script>
//import UnmatchedMessage from "../models/UnmatchedMessage.model";
import uuid4 from "../helpers/uuid4";

export default {
    name: "UnmatchedMessages",
    props: ["status"],
    data: function() {
        return {
            //main data
            unmatchedmessages: null,
            //pagination
            pageNo: 1,
            pageSize: 6,
            pagesCount: 0,
            totalMatches: null,
            searchString: "",
            orderBy: "",
            sortOrder: null,
            paginationTimeout: null,
            requestId: uuid4(),

            //form
            //unmatchedmessageFormVisible: false,
            //unmatchedmessageFormKey: 0,
            //unmatchedmessageFormUnmatchedMessage: new UnmatchedMessage()
        };
    },
    mounted: function() {
        this.getUnmatchedMessages();
    },
    //activated: function(){//when keep a live is brought back up},
    components: {
        //UnmatchedMessageForm
        //
    },
    methods: {
        getUnmatchedMessages() {
            var requestId = (this.requestId = uuid4());
            this.$store
                .dispatch("sms/getsmsunmatchedreplyaction", {
                    id: null,
                    urlParameters: {
                        pageNo: this.pageNo,
                        pageSize: this.pageSize,
                        searchString: this.searchString,
                        orderBy: this.orderBy,
                        sortOrder: this.sortOrder
                    },
                    requestId: requestId
                })
                .then(unmatchedmessagesResponse => {
                    if (this.requestId == unmatchedmessagesResponse.requestId) {
                        this.unmatchedmessages = unmatchedmessagesResponse.data.page;
                        this.totalMatches = unmatchedmessagesResponse.data.total;
                        this.pageSize = unmatchedmessagesResponse.data.pageSize;
                        this.pageNo = unmatchedmessagesResponse.data.pageNumber;
                        this.pagesCount = Math.ceil(
                            unmatchedmessagesResponse.data.total / this.pageSize
                        );
                    }
                });
        },
        paginationDebounce(debounceTime, isPaging) {
            if (!isPaging) {
                this.pageNo = 1;
                this.pagesCount = 0;
            }
            if (this.unmatchedmessages !== null) this.unmatchedmessages = null;
            clearTimeout(this.paginationTimeout);
            this.paginationTimeout = setTimeout(
                this.getUnmatchedMessages,
                debounceTime
            );
        },
        setSearch(value) {
            this.searchString = value;
            this.paginationDebounce(1000);
        },

        //FORM METHODS---------------------------------
        /*
        newUnmatchedMessage() {
            var unmatchedmessage = new UnmatchedMessage();
            unmatchedmessage.id = 0;
            this.loadUnmatchedMessageForm(unmatchedmessage);
        },
        loadUnmatchedMessageForm(unmatchedmessage) {
            this.unmatchedmessageFormUnmatchedMessage = new UnmatchedMessage().set(unmatchedmessage);
            this.unmatchedmessageFormKey = unmatchedmessage.id;
            this.unmatchedmessageFormVisible = true;
        },
        closeUnmatchedMessageForm() {
            this.unmatchedmessageFormVisible = false;
            this.unmatchedmessageFormUnmatchedMessage = new UnmatchedMessage();
            this.unmatchedmessageFormKey = null;
        },
        updateUnmatchedMessage() {
            this.paginationDebounce(0);
        },
        deleteUnmatchedMessage() {
            this.paginationDebounce(0);
        }
        */
    }
};
</script>

<style lang="stylus" scoped>
.entity-card
    /* background: linear-gradient(45deg, rgba(127,127,127,0.1), transparent,rgba(127,127,127,0.1)) */
    .center-content
        background-color: rgba(127, 127, 127, 0.15)

.pagination-bar
    // position: fixed;
    bottom: 0
    margin: auto
    left: 0
    right: 0
    padding-bottom: 0.1rem
    padding-top: 0.1rem
    /*
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border:1px solid rgba(127, 127, 127, 0.2)
    */

.theme--light
    .base-background
        background: #FFFFFF

.theme--dark
    .base-background
        background: #121212
</style>
